import { CATALOG, type CatalogEntry } from './catalog';

/** Games to suggest under a game page: same category first, then games that share a play mode. */
export function similarGames(game: CatalogEntry, count = 6): CatalogEntry[] {
  const others = CATALOG.filter((g) => g.id !== game.id);
  const same = others.filter((g) => g.category === game.category);
  const sharesMode = others.filter((g) => g.category !== game.category && g.modes.some((m) => game.modes.includes(m)));
  return [...same, ...sharesMode].slice(0, count);
}
